export enum ESTEP {
    PRACTICE_INFO = 1,
    AVAILABILITY = 2,
    TAX_INFO = 3,
    LAB = 4,
    SUCCESSFULLY = 5,
}
